// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "strahovanie #id_avtoid,\nstrahovanie #id_pricepid,\nstrahovanie #id_id {\n  width: 150px;\n  height: 250px;\n}\nstrahovanie #id_strahdata,\nstrahovanie #id_strahdata1,\nstrahovanie datepicker input {\n  width: 150px;\n}\nstrahovanie #id_avtoid .late,\nstrahovanie #id_pricepid .late {\n  background: #AA0022;\n  color: #FFFFFF;\n}\nstrahovanie button.big {\n  width: 150px;\n}\nstrahovanie button.fat {\n  width: 150px;\n  height: 35px;\n}", ""]);
// Exports
module.exports = exports;
